import { useEffect, useState, useCallback, useRef } from 'react';
import CloseLineIcon from 'remixicon-react/CloseLineIcon';
import MenuIcon from 'remixicon-react/Menu4LineIcon';
import navData from '../../data/nav';
import debounce from '../../utils/debounce';

const Header = ({ activeSection }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  const handleMenuToggle = useCallback(() => {
    setIsMenuOpen((prevState) => !prevState);
  }, []);

  const debouncedHandleScroll = useRef(
    debounce(() => {
      setIsScrolled(window.scrollY > 60);
    }, 100)
  ).current;

  useEffect(() => {
    window.addEventListener('scroll', debouncedHandleScroll);

    return () => {
      window.removeEventListener('scroll', debouncedHandleScroll);
    };
  }, [debouncedHandleScroll]);

  return (
    <>
      <header className='sticky top-0 left-0 w-full z-20 px-4 pt-4 md:px-6 md:pt-6'>
        <div
          className={`relative mx-auto flex max-w-[900px] items-center justify-between rounded-full border transition-all duration-300 px-5 md:px-7 h-16 md:h-[4.25rem] ${
            isScrolled
              ? 'bg-paper/80 backdrop-blur-md border-ink/10 shadow-[0_8px_30px_-12px_rgba(23,23,23,0.25)]'
              : 'bg-paper/40 backdrop-blur-sm border-transparent'
          }`}
        >
          <a className='font-serif text-lg md:text-xl font-semibold text-ink' href='/'>
            Kyle Moreau
          </a>

          <nav className='hidden space-x-1 md:flex'>
            {navData.navItems.map((navItem) => (
              <a
                href={navItem.navLink}
                className={`relative text-sm font-medium transition-colors duration-300 px-4 py-2 rounded-full ${
                  activeSection === navItem.sectionId
                    ? 'bg-ink text-paper'
                    : 'text-ink/60 hover:text-ink'
                }`}
                key={`desktop-${navItem.sectionId}`}
              >
                {navItem.navTitle}
              </a>
            ))}
          </nav>

          <div className='md:hidden'>
            <div
              className='w-9 h-9 border border-ink/20 text-ink flex items-center justify-center rounded-full cursor-pointer md:hidden'
              onClick={handleMenuToggle}
            >
              <MenuIcon size={18} />
            </div>
          </div>
        </div>
      </header>

      <nav
        className={`fixed inset-0 z-30 ${
          isMenuOpen ? 'translate-y-0' : '-translate-y-full'
        } transition-transform duration-[400ms] px-10 py-10 text-center bg-paper md:hidden`}
      >
        <span className='text-sm font-medium text-ink/50 block mb-10'>Menu</span>
        <h3 className='relative w-full mb-10 font-serif font-semibold text-xl text-ink'>
          Kyle Moreau
        </h3>
        <ul className='flex flex-col space-y-7'>
          {navData.navItems.map((navItem) => (
            <li onClick={handleMenuToggle} key={`mobile-${navItem.sectionId}`}>
              <a
                href={navItem.navLink}
                className='relative text-lg font-medium text-ink/70 transition-colors duration-300 hover:text-accent'
              >
                {navItem.navTitle}
              </a>
            </li>
          ))}
        </ul>

        <div
          className='absolute top-6 right-6 cursor-pointer text-ink'
          onClick={handleMenuToggle}
        >
          <CloseLineIcon className='scale-125' />
        </div>
      </nav>
    </>
  );
};

export default Header;
